export const ParametrizacaoParametro = "RotuloDeFaturamento"
export const ParametrizacaoDescricao = "Rótulo relativo ao faturamento a ser utilizado no painel de gastos"
